import SkyNetTable from 'app/shared-components/SkyNetTable'
import SkyNetDomain, {
    SidebarTab,
    getUrlsFromTableConfig,
} from 'app/shared-components/SkyNetDomain'
import useHasPermission from 'app/hooks/useHasPermission'
import {
    TableControlTypes,
} from 'app/shared-components/TableControls'
import useTabsByPermission from 'app/hooks/useTabsByPermission'
import useRelationshipsManagementRoutes from 'app/SkyNetRoutes/hooks/useRelationshipsManagementRoutes'
import useLabel from 'app/hooks/useLabel'

import EngagementCreateForm from './EngagementCreateForm'
import EngagementOverview from './EngagementOverview'
import EngagementUpdate from './EngagementUpdate'
import tableConfig from './engagement.config'

const tableControls: TableControlTypes[] = [
    TableControlTypes.Search,
    TableControlTypes.ShowArhived,
    TableControlTypes.ClearFilters,
    TableControlTypes.ClearSorting,
]

const Engagement = () => {
    const l = useLabel()
    const {
        Engagements: EngagementsRoutes,
    } = useRelationshipsManagementRoutes()
    const canCreate = useHasPermission(['relationships_sales'])

    const tabs: SidebarTab[] = useTabsByPermission([
        {
            tab: {
                label: l('OVERVIEW'),
                url: EngagementsRoutes.Overview.route,
                Component: EngagementOverview,
            },
            permission: true,
        },
        {
            tab: {
                label: l('DATA_UPDATE'),
                url: EngagementsRoutes.Update.route,
                Component: EngagementUpdate,
            },
            permission: true,
        },
    ])

    return (
        <SkyNetDomain
            actionComponents={{
                Create: canCreate ? EngagementCreateForm : null,
            }}
            sidebarTabs={tabs}
            defaultTab={EngagementsRoutes.Overview.route}
            name="Engagement"
            subdomainUrls={getUrlsFromTableConfig(tableConfig)}
        >
            <SkyNetTable
                tableControls={tableControls}
                tableConfig={tableConfig}
            />
        </SkyNetDomain>

    )
}

export default Engagement
